import { render, staticRenderFns } from "./AgentQuotes.vue?vue&type=template&id=7d748e1b&scoped=true"
import script from "./AgentQuotes.vue?vue&type=script&lang=js"
export * from "./AgentQuotes.vue?vue&type=script&lang=js"
import style0 from "./AgentQuotes.vue?vue&type=style&index=0&id=7d748e1b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d748e1b",
  null
  
)

export default component.exports